import React from "react";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const DEFAULT_RUN_SCHEDULE = { start: "06:00", end: "15:00", days: [0, 1, 2, 3, 4] };

/** v209 — Hour counter toggle + run schedule used to estimate hours. */
const MachineRunScheduleFields = ({ hasMeter, schedule, onChange }) => {
  const sc = schedule || DEFAULT_RUN_SCHEDULE;
  const setSc = (patch) => onChange({ run_schedule: { ...sc, ...patch } });
  const toggleDay = (d) =>
    setSc({ days: sc.days.includes(d) ? sc.days.filter((x) => x !== d) : [...sc.days, d].sort() });
  return (
    <div className="mt-3 border-2 border-black/15 rounded-xl p-3 flex flex-col gap-2" data-testid="machine-run-schedule">
      <label className="flex items-center gap-2 text-sm font-bold cursor-pointer">
        <input
          type="checkbox"
          data-testid="machine-has-meter-toggle"
          checked={!!hasMeter}
          onChange={(e) => onChange({ has_hour_meter: e.target.checked })}
          className="w-4 h-4"
        />
        This machine has an hour counter (staff read it)
      </label>
      {!hasMeter && (
        <>
          <div className="text-[11px] text-[#607087]">
            No counter — hours are estimated from this run schedule each time a linked item is taken.
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <div className="w-40">
              <input
                type="time"
                data-testid="machine-run-start"
                className="nb-input"
                value={sc.start}
                onChange={(e) => setSc({ start: e.target.value })}
              />
            </div>
            <span className="text-sm">to</span>
            <div className="w-40">
              <input
                type="time"
                data-testid="machine-run-end"
                className="nb-input"
                value={sc.end}
                onChange={(e) => setSc({ end: e.target.value })}
              />
            </div>
          </div>
          <div className="flex flex-wrap gap-1.5">
            {DAYS.map((d, i) => (
              <button
                key={d}
                type="button"
                data-testid={`machine-run-day-${i}`}
                onClick={() => toggleDay(i)}
                className={`px-2.5 py-1 rounded-full border-2 text-xs font-bold ${
                  sc.days.includes(i) ? "bg-[#0A3A7A] text-white border-[#0A3A7A]" : "bg-white border-black/20"
                }`}
              >
                {d}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default MachineRunScheduleFields;
